import React, { useState } from 'react'
import './MutedTroubleshootModal.scss'
import StudentInstruction from './StudentInstruction'
import RaiseHand from './PreCheckIllustrations/RaiseHand'
import { getCopyByGradeband } from '../../../services/ThemingService'
import { COPY_STRINGS } from '../../../constants/translatedCopy'
import microphoneBlue from '../../../images/ready-module/microphone-blue.svg'

export default function MutedTroubleshootModal(props) {
  const { handleRestart } = props
  const [showTroubleshoot, setShowTroubleshoot] = useState(false)
  
  const copy_strings = getCopyByGradeband(COPY_STRINGS, "student_raise_hand")

  if (showTroubleshoot) {
    return (
      <div className='muted-troubleshoot-modal'>
        <div className="muted-troubleshoot-modal__troubleshoot-view">
            <div className="muted-troubleshoot-modal__header">
              <img src={microphoneBlue} alt="Microphone" />
              <div className="muted-troubleshoot-modal__title">
                {copy_strings.troubleshoot_title}
              </div>
            </div>
            
            <div className="muted-troubleshoot-modal__tips-container">
              <div className="muted-troubleshoot-modal__instruction">
                {copy_strings.troubleshoot_instruction}
              </div>
              <ul className="muted-troubleshoot-modal__tips-list">
                <li>{copy_strings.troubleshoot_tip_unmute}</li>
                <li>{copy_strings.troubleshoot_tip_correct_mic}</li>
                <li>{copy_strings.troubleshoot_tip_volume}</li>
              </ul>
              <div className="muted-troubleshoot-modal__article">
                {copy_strings.troubleshoot_article_label}
                <a href="https://help.amiralearning.com/s/article/How-To-Always-Enable-the-Microphone" target="_blank" rel="noopener noreferrer">{copy_strings.troubleshoot_article_link_text}</a>
              </div>
              <div className="muted-troubleshoot-modal__restart-text">
                {copy_strings.troubleshoot_restart_text}
              </div>
            </div>

            <button className="primaryBtn" onClick={handleRestart}>{copy_strings.restart_button}</button>
          </div>
      </div>
    )
  }

  return (
    <div className='muted-troubleshoot-modal'>
      <StudentInstruction>
        <RaiseHand />
        <p>{copy_strings.mic_muted_teacher_instructions}</p>
        <button 
          className='teacher-troubleshoot-button' 
          onClick={() => setShowTroubleshoot(true)}
        >
          {copy_strings.teacher_troubleshoot}
        </button>
      </StudentInstruction>
    </div>
  )
}

